module.exports = __webpack_public_path__ + "static/media/supplies_token.2f962d98.png";